import { render, staticRenderFns } from "./SmartAttendance.vue?vue&type=template&id=539a8004&"
import script from "./SmartAttendance.vue?vue&type=script&lang=js&"
export * from "./SmartAttendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports